import { forwardRef, useState } from "react";

import { Button, ViewEyeOffIcon, ViewEyeOnIcon } from "..";
import { INPUT_CLASS_NAME, INPUT_CONTAINER_CLASS_NAME } from "./const";
import { TextFieldProps } from "./type";

export const PasswordField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ size = "md", isError = false, ...props }, ref) => {
    const [isPasswordMode, setIsPasswordMode] = useState(true);

    return (
      <div className={INPUT_CONTAINER_CLASS_NAME({ size, error: isError, isDisabled: props.disabled })}>
        <input
          ref={ref}
          {...props}
          type={isPasswordMode ? "password" : "text"}
          className={INPUT_CLASS_NAME({ isDisabled: props.disabled })}
        />
        <Button
          icon={isPasswordMode ? <ViewEyeOnIcon /> : <ViewEyeOffIcon />}
          iconType="only"
          styleType="textLine"
          type="button"
          onClick={() => setIsPasswordMode((prev) => !prev)}
          disabled={props.disabled}
        />
      </div>
    );
  },
);

PasswordField.displayName = "TextField";
